var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManLeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "88px",
    viewBox: "0 0 54 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ManLeg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ManLeg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4667339,85.8202731 C8.53288669,89.7316969 -2.43999985,82.5792377 0.493847393,78.6668237 L10.0281063,65.9542014 L21,73.1076508 L11.4667339,85.8202731",
    id: "Fill-123",
    fill: "#596FFF",
    transform: "translate(10.500000, 76.454201) rotate(-10.000000) translate(-10.500000, -76.454201) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,66.6972014 C11.798,44.8912014 15.22,13.4012014 35.566,0.969201363 C50.8153768,-2.69723253 56.4537102,4.03876747 52.481,21.1772014 C51.944,22.7732014 51.23,24.3052014 50.352,25.7432014 L20.834,75.7152014 C14.357,79.5842014 4.896,71.1042014 4,66.6972014 Z",
    id: "Fill-124",
    fill: "#223A6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManLeg);
export default __webpack_public_path__ + "static/media/ManLeg.cf170d94958a12a7dd4f6d4ff404bfb0.svg";
export { ForwardRef as ReactComponent };